// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PVQr","right":"styles_right__1Uc9O"};